module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/planner.worker.e373a694.js");
};